import { render, staticRenderFns } from "./globalPiratesInfo.vue?vue&type=template&id=1eb3e638"
import script from "./globalPiratesInfo.vue?vue&type=script&lang=js"
export * from "./globalPiratesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports